/**
 * 审批管理 / 备案申请
 */
import { SAFETY_MFG_URL } from '@config'

// 定额保证金信息
export const GET_FIXED_DEPOSIT_INFO = {
    url: `${SAFETY_MFG_URL}/workflow/report/history_report_detail`,
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 30000
}

// 状态信息
export const GET_STATUS_INFO = {
    url: `${SAFETY_MFG_URL}/workflow/report/apply_view`,
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 30000
}

// 审批内容
export const GET_APPLICATION_CONTENT_DATA = {
    url: `${SAFETY_MFG_URL}/workflow/report/historyInfo`,
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 30000
}

// 取消申请
export const CANCEL_APPLICATION = {
    url: `${SAFETY_MFG_URL}/workflow/report/ent/cancel`,
    method: 'post',
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    },
    timeout: 30000
}
